import { legacy_createStore as createStore,combineReducers } from "redux";
import {persistReducer,persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage'
import {dataReducer} from './data_reducer';


// 创建rootReducer
const rootReducer = combineReducers({
    uData: dataReducer
});
const persistConfig={
    key:'root',
    storage,
    whitelist: ['uData'], // 只持久化 uData 相关的状态
    blacklist: [''] // 不持久化 someOtherState 的状态
}
const persistedReducer=persistReducer(persistConfig,rootReducer);

const store = createStore(persistedReducer);
const persistor = persistStore(store);
 
export { store, persistor };
// export const store=createStore(dataReducer);